var moo = require("@webhare-system/frameworks/mootools/core");

var Class = moo.Class;


var ListDataSource = new Class(
{ list: null
, setListView:function(list)
  {
    this.list = list;
  }

, isSelected:function(rownum)
  {
    return false;
  }

, clearSelection:function()
  {
  }

, getRowParent: function(rownum)
  {
    return -1;
  }

  // FIXME: test
, getSelectableRowBefore: function(rownum)
  {
    if (this.list.length == 0)
      return -1;

    if (rownum < 1 || rownum > this.list.length)
    {
      console.error("Invalid row number");
      return -1;
    }

    return rownum - 1;

    /*
    rownum--;
    while (rownum > -1)
    {
      if (this.list[rownum].selectable)
        return rownum;

      rownum--;
    }

    return -1;
    */
  }

  // FIXME: test
, getSelectableRowAfter: function(rownum)
  {
    if (this.list.length == 0)
      return -1;

    if (rownum < this.list.length - 1)
      return rownum + 1;

    return -1; // no row found

    /*
    rownum++;

    var rowcount = this.flatrows.length;
    while (rownum < rowcount)
    {
      if (this.flatrows[rownum][0].selectable)
        return rownum;

      rownum++;
    }

    return -1;
    */
  }

, setSelectionForRange:function(startrow, lastrow, selected)
  {
  }
, startSelectionUpdateGroup: function()
  {
    // dummy
  }
, finishSelectionUpdateGroup: function()
  {
    // dummy
  }


//, sendNumRows: function() { }
, sendFooterRows: function()
  {

  }

  /** Selected the first row (starting matching at first selected row) that matches the regex
  */
, selectFirstMatchFromCurrent: function(tomatch, searchidx)
  {
  }
});

module.exports = ListDataSource;



//////////////////
// WEBPACK FOOTER
// /opt/wh/whtree/modules/tollium/web/ui/components/listview/listdatasource.js
// module id = 1146
// module chunks = 0